var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 18.5L18.75 8.64258C18.7499 8.15956 18.5945 7.69123 18.3096 7.30566L18.1797 7.14551L15.3779 4.00293C14.951 3.52402 14.3398 3.25001 13.6982 3.25L7.5 3.25C6.25736 3.25 5.25 4.25736 5.25 5.5L5.25 18.5C5.25 19.7426 6.25736 20.75 7.5 20.75L16.5 20.75C17.7426 20.75 18.75 19.7426 18.75 18.5Z",
    fill: "white",
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4287 8.83398L14.0716 8.83398C13.5193 8.83398 13.0716 8.38627 13.0716 7.83398L13.0716 3.55621",
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.9983cdaaf5dc80ade724e47aa5386df4.svg";
export { ForwardRef as ReactComponent };